import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { AnalysedProposalsController } from "./controller";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";
import { Spinner, View, VStack } from "@gluestack-ui/themed";
import { ReportCharts } from "@repo/core/components/chart/ReportCharts";
import { DataTable } from "@repo/core/components/core/DataTable";
import { MustShow } from "@repo/core/components/core/MustShow";
import { Modal } from "@repo/core/components/layout/Modal";
import { ReportSelectFilters } from "@repo/core/components/layout/ReportSelectFilters";
import { getReportCardByReportType } from "../../components/ReportCard/utils";
import { ReportScreenHeader } from "../../components/ReportScreenHeader";
import { ReportCardEnum } from "@repo/core/types/reports";
import {
  ChartVisualizationData,
  LineValueData
} from "@repo/core/components/chart/ReportCharts/types";
import { EmptyState } from "@repo/core/components/layout/EmptyState";

const AnalysedProposals = () => {
  const {
    isMobile,
    onChangeStartDate,
    onChangeEndDate,
    table,
    handleExportTable,
    filterModalRef,
    topRightText,
    isFetchingAnalysedProposals,
    chartBarData,
    chartLineData,
    cardsData,
    filterStartDate,
    filterEndDate,
    hasReportData,
    handleSelectFilters
  } = AnalysedProposalsController();
  return (
    <>
      <Scaffolds.Root minHeight={"$100vh"} showHeader={false}>
        <Scaffolds.StoreSelect
          showHeader={false}
          statusBarVariant={StatusBarVariantEnum.GREEN}
          storeSelectorVariant={StoreSelectorVariantEnum.SHOPKEEPER}
          topRightText={topRightText}
          topRightIcon="refresh"
        >
          <Scaffolds.Page
            showHeader
            pt={!isMobile ? "$3" : "$0"}
            title="Propostas Analisadas"
            p="$0"
            bg="$backgroundLight0"
            rightIcon={isMobile ? undefined : "file-export"}
            rightIconSize={20}
            rightWebLabel={isMobile ? undefined : "Exportar"}
            onPressRightIcon={isMobile ? undefined : handleExportTable}
          >
            <VStack flex={1} px={isMobile ? 0 : "$4"} gap={isMobile ? 0 : "$6"}>
              <ReportScreenHeader
                filterModalRef={filterModalRef}
                defaultStartDate={filterStartDate}
                defaultEndDate={filterEndDate}
                onChangeStartDate={onChangeStartDate}
                onChangeEndDate={onChangeEndDate}
                handleSelectFilter={handleSelectFilters}
              />

              <MustShow
                isVisible={!isFetchingAnalysedProposals && hasReportData}
                fallback={
                  <MustShow
                    isVisible={isFetchingAnalysedProposals}
                    fallback={
                      <EmptyState
                        flex={1}
                        text="Nenhum relatório disponível para o período selecionado."
                      />
                    }
                  >
                    <VStack
                      flex={1}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Spinner size={60} />
                    </VStack>
                  </MustShow>
                }
              >
                <ReportCharts.Bar
                  data={chartBarData?.data as ChartVisualizationData[]}
                  lineData={chartLineData?.data as LineValueData}
                  maxValue={2000}
                  maxDomain={1600}
                  numberOfGridLines={10}
                  showRightLabels
                  rightLabelsTransform={(tick) =>
                    `${Math.round((tick / 2000) * 100)}%`
                  }
                />

                <MustShow isVisible={!isMobile}>
                  <DataTable table={table} />
                </MustShow>
                <MustShow isVisible={isMobile}>
                  <VStack>
                    {cardsData?.map((card) =>
                      getReportCardByReportType(
                        ReportCardEnum.ANALYSED_PROPOSALS,
                        card
                      )
                    )}
                  </VStack>
                </MustShow>
              </MustShow>
            </VStack>
          </Scaffolds.Page>

          <Modal ref={filterModalRef}>
            <View p="$2" bg="$backgroundLight0">
              <ReportSelectFilters
                onClose={() => filterModalRef.current?.close()}
              />
            </View>
          </Modal>
        </Scaffolds.StoreSelect>
      </Scaffolds.Root>
    </>
  );
};
export default AnalysedProposals;
